"use strict";
require("./src/styles/global.css");
